import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';

const { Cell } = Table;

const DurationCell = ({ rowData, dataKey, ...props }) => {
  const duration = rowData[dataKey];
  return <Cell {...props}>{duration > 0 ? `${duration} Mins` : 'N/A'}</Cell>;
};

DurationCell.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number
  }),
  dataKey: PropTypes.string.isRequired
};

DurationCell.defaultProps = {
  rowData: null
};

export default DurationCell;
